export default {
  name: {
    id: 'rm_metal_boron_name',
    defaultMessage: 'Boron',
  },
  smartphoneLabel: {
    id: 'rm_metal_boron_smartphone_label',
    defaultMessage: 'Trace (invisible to the naked eye)',
  },
  whatItDoesText: {
    id: 'rm_metal_boron_what_it_does',
    defaultMessage:
      'Borates help make smartphone display glass tough and heat-resistant, while boron compounds are used in semiconductors and advanced materials. Boron also gives NdFeB magnets exceptional magnetic strength for speakers and haptic motors, and fine-tunes camera sensors’ response to incoming light.',
  },
  extractionText1: {
    id: 'rm_metal_boron_extraction_p1',
    defaultMessage:
      'Boron is not mined as a native metal. It is obtained from borate minerals such as tincal, kernite, colemanite and ulexite. Most deposits are mined using open-pit methods, while some boron-rich brines are recovered through evaporation. The ore is crushed, washed and concentrated, then processed into boric acid, borax or boron oxide. These compounds are further purified for use in glass, semiconductors, ceramics and permanent magnets.',
  },
  quickFactText: {
    id: 'rm_metal_boron_quick_fact',
    defaultMessage:
      'Boron is not mined as a metal: it is obtained from borate minerals and helps give NdFeB magnets their exceptional magnetic strength for compact smartphone speakers and haptic motors.',
  },
  envSummaryText: {
    id: 'rm_metal_boron_env_summary',
    defaultMessage:
      'Boron[^***] is obtained mainly from borate deposits in Turkey and the United States, including large open-pit operations in arid regions. Mining can disturb these landscapes and generate waste rock and sludge. Refining may have a greater environmental impact than mining and beneficiation because it uses sulfuric acid, steam, hydrogen peroxide and other chemicals.',
  },
  envWaterText: {
    id: 'rm_metal_boron_env_water_text',
    defaultMessage:
      'Boron can enter groundwater naturally when water leaches through borate-bearing rocks and soils. Mining and processing can add wastewater, brines and dissolved boron to local water systems.',
  },
  envSoilText: {
    id: 'rm_metal_boron_env_soil_text',
    defaultMessage:
      'Open-pit mining removes soil and rock, while waste rock and boron-bearing sludge accumulate near processing sites. Chemical residues and leaching can affect surrounding soils. Some borate sludge can be reused in ceramic products, reducing part of the waste stream.',
  },
  envBiodiversityText: {
    id: 'rm_metal_boron_env_biodiversity_text',
    defaultMessage:
      'Open pits, access roads, processing facilities and waste-storage areas can disturb habitats, particularly in arid regions where many borate deposits occur. No global, boron-specific biodiversity assessment was identified.',
  },
  humanSummaryText: {
    id: 'rm_metal_boron_human_summary',
    defaultMessage:
      'Turkey’s boron-mining sector, operated by the state-owned company Eti Maden, is among the more regulated and transparent mining operations covered in this sheet. The validated sources document no classification of boron as a conflict mineral, child labour or major community-displacement crisis. However, the concentration of production can make some mining communities economically dependent on a single industry, increasing their vulnerability to market fluctuations and employment insecurity. High exposure to certain boron compounds can also pose health risks.',
  },
  humanHealthText: {
    id: 'rm_metal_boron_human_health_text',
    defaultMessage:
      'Boron is naturally present in food and water, but high exposure to boric acid or borax can cause gastrointestinal and neurological symptoms. Boron trioxide is classified as toxic for reproduction. Evidence on the effects of high boron intake through food and drinking water remains limited.',
  },
  humanLegalText: {
    id: 'rm_metal_boron_human_legal_text',
    defaultMessage:
      'EU Regulation 2019/1009 controls boron levels in fertilisers, while occupational exposure limits apply to boron oxide in several countries. These measures concern product and worker safety, not access to remedy for mining communities.',
  },
  geoSummaryText: {
    id: 'rm_metal_boron_geo_summary',
    defaultMessage:
      'Boron supply is concentrated across a small group of countries. Turkey and the United States together account for around two-thirds of global borate production, while the European Union is entirely dependent on imports. Turkey supplies approximately 99% of the EU’s natural borate imports and around 69% of its processed borate imports.',
  },
  geoDugText: {
    id: 'rm_metal_boron_geo_dug_text',
    defaultMessage:
      'Turkey is the largest producer of borates. Its share is estimated at around one quarter of global production, although the exact figure is difficult to establish because countries report different borate products and some data are unavailable.',
  },
  geoProcessedText: {
    id: 'rm_metal_boron_geo_processed_text',
    defaultMessage:
      'Global processed-borate production is led by Turkey (46%), followed by the United States (22%), Kazakhstan (9%), Chile (7%), Bolivia (5%) and China (4%). These are processed-borate trade and production figures, not data on semiconductor-grade boron.',
  },
  geoLeverageText: {
    id: 'rm_metal_boron_geo_leverage_text',
    defaultMessage:
      'No boron-specific export restrictions are documented in these sources.',
  },
  supplySummaryText: {
    id: 'rm_metal_boron_supply_summary',
    defaultMessage:
      'Boron supply is currently available, but production is concentrated in a small number of countries, particularly Turkey and the United States. Demand from clean-energy technologies is also rising, while new supply capacity is expected to expand only gradually.',
  },
  supplyReservesText: {
    id: 'rm_metal_boron_supply_reserves_text',
    defaultMessage:
      'Known borate reserves are large but concentrated. The USGS reports approximately 950 million tonnes of reserves in Turkey, 48 million tonnes in the United States, 40 million tonnes in Russia, 35 million tonnes in Chile, 9.1 million tonnes in China and 4 million tonnes in Peru. These figures concern borate minerals, not elemental boron.',
  },
  supplyDemandText: {
    id: 'rm_metal_boron_supply_demand_text',
    defaultMessage:
      'Boron demand from clean-energy technologies is projected to increase by approximately 89%, driven mainly by wind power generation. Boron is also used in high-performance aerospace alloys and NdFeB permanent magnets, which power motors in applications such as electric vehicles and wind turbines. Demand from these sectors could add to the pressure.',
  },
  recyclingSummaryText: {
    id: 'rm_metal_boron_recycling_summary',
    defaultMessage:
      'Recycling is very limited. Many borate applications, including fertilisers, detergents and chemicals, consume or disperse the material during use. Glass and ceramic products can sometimes be downcycled, but functional recovery of boron is generally difficult.',
  },
  recyclingInputText: {
    id: 'rm_metal_boron_recycling_input_text',
    defaultMessage:
      'Documented recycling of boron is negligible, with available recycling indicators below 1%.',
  },
  recyclingOutlookText: {
    id: 'rm_metal_boron_recycling_outlook_text',
    defaultMessage:
      'Not on its own. Borates are often consumed or dispersed during use, limiting recovery. Experimental processes have recovered boron from spent NdFeB magnets as sodium borate with more than 97% purity, but this approach has not yet been implemented at commercial scale.',
  },
  footnote1Text1: {
    id: 'rm_metal_boron_footnote_1_p1',
    defaultMessage:
      'As boron is not covered by the ADEME 2024 study, its environmental, social, geopolitical and supply-risk scores were calculated by Back Market’s Sustainability team using ADEME’s methodology, public sources and AI assistance. These scores carry greater uncertainty. See the Sources tab for the full methodology and references.',
  },
  footnote2Text1: {
    id: 'rm_metal_boron_footnote_2_p1',
    defaultMessage:
      'Absolute volumes only. Percentage breakdown not calculable as stated explicitely in the USGS MCS 2025 report: “World totals cannot be calculated because production and reserves are not reported in a consistent manner by all countries”',
  },
  footnote3Text1: {
    id: 'rm_metal_boron_footnote_3_p1',
    defaultMessage:
      'Boron is not mined as an elemental metal. It occurs naturally in borate minerals, such as tincal, kernite, colemanite and ulexite. The USGS 2025 report and SCRREEN3 factsheet data mainly refer to borate minerals and boron compounds, reported as borates or B₂O₃ equivalent, rather than to boron metal itself.',
  },
} as const
